// Generated by CoffeeScript 2.7.0
// ==============================================================================
// MODULES - COMPONENTS - AHA AREA
// ==============================================================================
import $ from "jquery";

$(function() {
  var $ahaAreaHead;
  // Set background image dynamically.
  $ahaAreaHead = $('.C--ahaArea_head');
  if ($ahaAreaHead[0]) {
    return $ahaAreaHead.each(function(index, elm) {
      return $(elm).css({
        backgroundImage: `url(${$(elm).attr('data-image-path')})`
      });
    });
  }
});

